import { assert } from '../app/logger.js';
import { Dialog } from '../controls/dialog.js';

/**
 * Reject share dialog.
 */
class RejectTripShareDialog extends Dialog {
  show(trip) {
    assert(trip, `[trip-planning] no id for RejectTripShareDialog`);

    this.#trip = trip;
    this.designationElement.textContent = trip.name;

    return super.show();
  }

  static tagName = 'reject-trip-share-dialog';
  static titleMarkup = `Confirm`;
  static bodyMarkup = `
    <form class='default remove-cl-dialog'>
      <label>
        <span>Reject
          <span class='designation'></span> shared trip?
        </span>
      </label>
    </form>
  `;

  static buttons = {
    accept: {
      label: 'Reject',
    },
    cancel: {
      label: 'Cancel',
      default: true,
    },
  };

  static get selectors() {
    const baseSelectors = super.selectors;
    const { Body } = baseSelectors;
    return Object.assign({}, baseSelectors, {
      Designation: `${Body} .designation`,
    });
  }

  static get elements() {
    return {
      designationElement: this.selectors.Designation,
    };
  }

  checkValidity() {
    return this.optionsElement.checkValidity();
  }

  get data() {
    return this.#trip;
  }

  #trip;
}

RejectTripShareDialog.defineCustomElement();

export { RejectTripShareDialog };
